import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const current = i18n.resolvedLanguage ?? 'nb';
    const label = current.startsWith('en') ? 'EN' : 'NO';

    // Screen readers hear "Language: NO" instead of a bare "NO".
    const title = (
        <>
            <span className="visually-hidden">{t('common.language')}: </span>
            {label}
        </>
    );

    return (
        <NavDropdown title={title} align="end" id="language-switcher">
            <NavDropdown.Item
                active={current.startsWith('nb')}
                onClick={() => void i18n.changeLanguage('nb')}
            >
                {t('common.norwegian')}
            </NavDropdown.Item>
            <NavDropdown.Item
                active={current.startsWith('en')}
                onClick={() => void i18n.changeLanguage('en')}
            >
                {t('common.english')}
            </NavDropdown.Item>
        </NavDropdown>
    );
}
